import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import {
  civilRoles,
  customStyles,
  elecRoles,
  generalRoles,
  HOST_URL,
  mechRoles,
  processRoles,
  structuralRoles,
  subContractorRoles,
} from "../../helpers/constants/Constants";
import Select from "react-select";
import {
  refreshSheets,
  updateProjectAssetSheetConfig,
  updateProjectAssetSheets,
} from "../../helpers/axios/projectsAxios";
import Modal from "react-bootstrap/Modal";
import { ButtonGroup } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import LoadingScreen from "../loadingScreen/LoadingScreen";
import { getForgeToken } from "../../helpers/actions/RequestData";
import {
  LAUNCH_VIEWER,
  MODEL_FILTER_STATE,
  MODEL_LOADED,
  SELECTED_DRAWING_SET,
  SELECTED_MODELS,
  SELECTED_SHEET,
  SHEETS_SELECTED,
  updateModelState,
} from "../../helpers/reducers/ModelReducer";
import {
  ACC_SHEETS,
  SHEET_UPDATE_INFO,
  updateGlobalState,
} from "../../helpers/reducers/GlobalReducer";
/* global Autodesk, THREE */ // eslint-disable-line

const Sheets = ({ viewerState = null }) => {
  const {
    selectedProject,
    userDetails,
    accDrawingSets,
    accSheets,
    regionalStatuses,
    allDocs,
  } = useSelector((state) => state.globalReducer);
  const { selectedDrawingSet, selectedSheet } = useSelector(
    (state) => state.modelReducer,
  );
  const [localSelectedSheet, setLocalSelectedSheet] = useState(null);
  const [selectedState, setSelectedState] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedDiscipline, setSelectedDiscipline] = useState("");
  const [isSheetsLoading, setIsSheetsLoading] = useState(false);

  const dispatch = useDispatch();

  const panelSelectStyles = {
    ...customStyles,
    control: (provided, state) => ({
      ...provided,
      fontSize: "12px",
      background:
        "linear-gradient(120deg, rgba(58,58,58,0.34) 0%, rgba(0,93,133,0.42) 100%)",
      borderColor: state.isFocused
        ? "rgba(147,213,0,0.72)"
        : "rgba(242,242,242,0.34)",
      minHeight: "34px",
      height: "34px",
      borderRadius: "999px",
      boxShadow: state.isFocused
        ? "0 0 0 2px rgba(147,213,0,0.24), 0 8px 18px rgba(58,58,58,0.22)"
        : "0 8px 18px rgba(58,58,58,0.2)",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "rgba(242,242,242,0.96)",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "rgba(242,242,242,0.7)",
    }),
    input: (provided) => ({
      ...provided,
      color: "rgba(242,242,242,0.96)",
    }),
    option: (provided, state) => ({
      ...provided,
      color: "rgba(242,242,242,0.95)",
      background: state.isSelected
        ? "linear-gradient(120deg, rgba(147,213,0,0.42), rgba(156,197,202,0.28))"
        : state.isFocused
          ? "linear-gradient(120deg, rgba(147,213,0,0.26), rgba(156,197,202,0.2))"
          : "rgba(0,0,0,0)",
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "12px",
      border: "1px solid rgba(242,242,242,0.24)",
      background:
        "linear-gradient(165deg, rgba(58,58,58,0.96) 0%, rgba(0,93,133,0.92) 100%)",
      boxShadow: "0 14px 28px rgba(58,58,58,0.28)",
      overflow: "hidden",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: "rgba(156,197,202,0.95)",
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };

  let viewerApp;
  let viewer;

  const drawingSetSelectHandler = async (e) => {
    if (!e?.data || isSheetsLoading) {
      return;
    }

    const tempSelectedModel = [
      {
        id: e.data?.drawingSet?.relationships.derivatives.data.id,
        documentName: e.data?.drawingSet?.attributes.name,
        // storageLocation:
        //   e.data?.drawingSet?.relationships.storage.meta.link.href,
        accVersion: e.data?.drawingSet?.attributes.versionNumber,
        discipline: e.data?.drawingSet?.discipline,
        drawingSetId: e.data?.drawingSet?.id,
        description: e.data?.drawingSet?.description,
        docNumber: e.data?.drawingSet?.docNumber,
        projectAssetTasksIds: e.data?.drawingSet?.projectAssetTasksIds,
        projectAssetId: e.data?.drawingSet?.projectAssetId,
        assetId: e.data?.drawingSet?.projectAsset?.assetId,
        setUpdated: e.data?.drawingSet?.setUpdated,
      },
    ];
    const asset = e.data?.drawingSet?.attributes?.displayName.split(" - ")[1];

    dispatch(
      updateModelState({
        value: false,
        stateName: LAUNCH_VIEWER,
      }),
    );
    dispatch(
      updateModelState({
        value: e.data,
        stateName: SELECTED_DRAWING_SET,
      }),
    );
    dispatch(
      updateModelState({
        value: tempSelectedModel,
        stateName: SELECTED_MODELS,
      }),
    );

    dispatch(
      updateModelState({
        value: { process: { processArea: asset } },
        stateName: MODEL_FILTER_STATE,
      }),
    );
    setIsSheetsLoading(true);

    try {
      await getSheetInfo(
        e.data?.drawingSet?.relationships.derivatives.data.id,
        tempSelectedModel,
      );
    } finally {
      setIsSheetsLoading(false);
    }
    //add function here to check the status of the drawing set and store it so we can use for validation on discipline buttons.
    // const status = checkDrawingSetStatus(e.data);
    // setDrawingSetStatus(status);
    // setTimeout(() => {
    //   dispatch(
    //     updateModelState({
    //       value: true,
    //       stateName: LAUNCH_VIEWER,
    //     })
    //   );
    //   dispatch(
    //     updateModelState({
    //       value: false,
    //       stateName: MODEL_LOADED,
    //     })
    //   );
    // }, 200);
  };

  const checkDrawingSetStatus = (drawingSet) => {
    const primaryDisciplineCheck = [];
    const secondaryDisciplineCheck = [];
    const publishedDisciplineCheck = [];
    // const primaryDiscipline = drawingSet?.drawingSet?.attributes?.displayName
    //   .split(".")[0]
    //   .split(" - ")[2];
    const primaryDiscipline = drawingSet?.drawingSet?.discipline;

    regionalStatuses?.forEach((status) => {
      if (status.published) {
        publishedDisciplineCheck.push(status.code);
      }
      if (status.primary) {
        primaryDisciplineCheck.push(status.code);
      }
      if (status.secondary) {
        secondaryDisciplineCheck.push(status.code);
      }
    });

    if (!drawingSet?.linkedFiles || !Array.isArray(drawingSet.linkedFiles)) {
      return "WIP";
    }

    const primaryDisciplineStatuses = [];
    const otherModelsStatuses = [];

    drawingSet.linkedFiles.forEach((file) => {
      const docNumber = file.modelName.split(".")[0];
      const doc = allDocs.find((d) => d.docNumber === docNumber);
      if (doc?.discipline === primaryDiscipline) {
        primaryDisciplineStatuses.push(doc?.status);
      } else {
        otherModelsStatuses.push(doc?.status);
      }
    });

    if (
      primaryDisciplineStatuses.length === 0 &&
      otherModelsStatuses.length === 0
    ) {
      return "WIP";
    }

    var allPublished =
      primaryDisciplineStatuses.every((status) => status === "Published") &&
      otherModelsStatuses.every((status) =>
        publishedDisciplineCheck.includes(status),
      );

    var allPrimaryPrimaryStatuses = primaryDisciplineStatuses.every((status) =>
      primaryDisciplineCheck.includes(status),
    );
    var allOtherSecondaryStatuses = otherModelsStatuses.every((status) =>
      secondaryDisciplineCheck.includes(status),
    );

    var anyWip =
      primaryDisciplineStatuses.includes("S0") ||
      otherModelsStatuses.includes("S0");

    if (allPublished) {
      return "Published";
    }
    if (allPrimaryPrimaryStatuses && allOtherSecondaryStatuses) {
      return "S4";
    }
    if (!anyWip && allOtherSecondaryStatuses) {
      return "S1";
    }
    if (anyWip) {
      return "WIP";
    }
    // If no statuses match the above conditions, return WIP
    return "WIP";
  };

  const onTreeCreated = async (model) => {
    const instanceTree = model.getData().instanceTree;
    const allDbIdsStr = Object.keys(instanceTree.nodeAccess.dbIdToIndex);
    const allDbIdsInt = allDbIdsStr.map(function (id) {
      return parseInt(id);
    });
    return new Promise((resolve, reject) => {
      model.getBulkProperties2(
        allDbIdsInt,
        // {},
        {
          propFilter: ["Updated 3", "Sheet Name", "Sheet Number", "Updated"],
        },
        resolve,
        reject,
      );
    });
  };

  const getSheetInfo = async (urn, drawingSet) => {
    const urns = [{ urn: urn }];
    const options = {
      env: "AutodeskProduction",
      getAccessToken: getForgeToken,
    };

    function loadManifest(documentId) {
      return new Promise((resolve, reject) => {
        const onDocumentLoadSuccess = (doc) => {
          // onDocumentLoadSuccessActions(doc);
          doc.downloadAecModelData(() => resolve(doc));
        };
        Autodesk.Viewing.Document.load(
          documentId,
          onDocumentLoadSuccess,
          reject,
        );
      });
    }

    return new Promise((resolve, reject) => {
      Autodesk.Viewing.Initializer(options, async function () {
        viewer = document.getElementById("viewerDivProject");
        viewerApp = new Autodesk.Viewing.AggregatedView();
        viewerApp.init(viewer, {});
        let results = [];
        try {
          const tasks = [];
          urns.forEach((md) => tasks.push(loadManifest("urn:" + md.urn)));
          await Promise.all(tasks)
            .then((docs) =>
              Promise.resolve(
                docs.map((doc) => {
                  const bubbles = doc
                    .getRoot()
                    .search({ type: "geometry", role: "2d" }); //role:"2d"
                  if (bubbles.length === 0) return null;
                  return bubbles;
                }),
              ),
            )
            .then(async (bubbles) => {
              // results = bubbles[0].slice(1);
              results = bubbles[0];
              // saveSheets(bubbles[0].slice(1), drawingSet); //move where this is done and use results?
            });

          if (!results) {
            throw new Error("No 2D geometry found in the document.");
          }
          viewerApp.setNodes(results);

          await viewerApp.waitForLoadDone({
            propDb: true,
            geometry: true,
          });

          const modelTasks = results.map((bubble, i) => {
            const model = viewerApp.getModel(bubble);
            return onTreeCreated(model);
          });

          const modelResults = await Promise.all(modelTasks);
          // Flatten results
          const allData = modelResults.flat();
          const sortedData = allData.map((sheet) => {
            return {
              dbId: sheet.dbId,
              updated: sheet.properties.find(
                (prop) => prop.displayName === "Updated",
              )?.displayValue,
              sheetName: `${
                sheet.properties.find(
                  (prop) => prop.displayName === "Sheet Number",
                )?.displayValue
              } - ${
                sheet.properties.find(
                  (prop) => prop.displayName === "Sheet Name",
                )?.displayValue
              }`,
            };
          });
          //add updated field from sorted data to the results array based on the sheet name matching
          results = results.map((sheet) => {
            const matchingSheet = sortedData.find(
              (s) => s.sheetName === sheet.data.name,
            );
            return {
              ...sheet,
              updated: matchingSheet ? Boolean(matchingSheet.updated) : false, //default to false if no match found
            };
          });
          await saveSheets(results, drawingSet);
          dispatch(
            updateGlobalState({
              value: sortedData,
              stateName: SHEET_UPDATE_INFO,
            }),
          );
          resolve();
          //add in function to call axios and update sheets in DB with sortedData info
        } catch (error) {
          console.error("Error in LoadProjectData:", error);
          reject(error);
        } finally {
          if (viewerApp?.viewer) {
            viewerApp.viewer.finish();
          }
          viewerApp = null;
          Autodesk.Viewing.shutdown();
        }
      });
    });
  };

  const saveSheets = async (sheeets, drawingSet) => {
    const tempSheets = sheeets?.map((o) => {
      return {
        name: o.data.name,
        guid: o.data.guid,
        updated: o.updated,
      };
    });
    const response = await axios.post(
      HOST_URL + "/forgedata/updateSheets",
      {
        data: {
          sheets: tempSheets,
          drawingSet: drawingSet,
          selectedProject: selectedProject,
        },
      },
      {
        withCredentials: true,
      },
    );

    const sortedData = response.data.sort((a, b) =>
      a.sheetName.localeCompare(b.sheetName),
    );
    dispatch(
      updateGlobalState({
        value: sortedData,
        stateName: ACC_SHEETS,
      }),
    );

    return sortedData;
  };

  const onSheetClick = (sheet) => {
    dispatch(
      updateModelState({
        value: false,
        stateName: LAUNCH_VIEWER,
      }),
    );
    dispatch(
      updateModelState({
        value: true,
        stateName: SHEETS_SELECTED,
      }),
    );
    dispatch(
      updateModelState({
        value: sheet,
        stateName: SELECTED_SHEET,
      }),
    );

    //////
    setTimeout(() => {
      dispatch(
        updateModelState({
          value: true,
          stateName: LAUNCH_VIEWER,
        }),
      );
      dispatch(
        updateModelState({
          value: false,
          stateName: MODEL_LOADED,
        }),
      );
    }, "200");
  };

  const checkColour = (value) => {
    switch (value) {
      case "not approved":
      case "not reviewed":
        return "red";
      case "amber":
        return "orange";
      case "reviewed":
      case "approved":
        return "green";
      default:
        return "white";
    }
  };

  const openModal = (discipline, sheet) => {
    setSelectedDiscipline(discipline);
    setLocalSelectedSheet(sheet);
    setModalOpen(true);
  };

  const onModalClose = () => {
    setModalOpen(false);
    setSelectedDiscipline("");
  };

  const disciplineStateOptions = [
    selectedDiscipline === "dm"
      ? {
          value: "approved",
          label: "Approved",
        }
      : {
          value: "reviewed",
          label: "Reviewed",
        },
    {
      value: "amber",
      label: "Change Pending",
    },
    selectedDiscipline === "dm"
      ? {
          value: "not approved",
          label: "Rejected",
        }
      : {
          value: "not reviewed",
          label: "Rejected",
        },
  ];

  const stateSelector = (e) => {
    setSelectedState({
      value: e.value,
      label: e.label,
    });
  };

  const updateState = async (e) => {
    // e.preventDefault();
    //update state in DB from local state before clearing and refreshing

    await updateProjectAssetSheets(
      selectedDiscipline,
      selectedState.value,
      localSelectedSheet,
    );
    refreshAssetSheets(selectedDrawingSet.drawingSet.id);
    // refreshAssetSheets(localSelectedSheet.projectAssetId);
    setSelectedState(null);
    setLocalSelectedSheet(null);
    setSelectedDiscipline("");
    setModalOpen(false);
  };

  const refreshAssetSheets = async (projectAssetSetId) => {
    const tempSheets = await refreshSheets(projectAssetSetId);
    const sortedData = tempSheets.data.sort((a, b) =>
      a.sheetName.localeCompare(b.sheetName),
    );
    dispatch(
      updateGlobalState({
        value: sortedData,
        stateName: ACC_SHEETS,
      }),
    );
  };

  const isValid = (discipline) => {
    switch (discipline) {
      case "Civil":
      case "Civil Engineer":
        if (civilRoles.includes(userDetails?.role)) {
          return true;
        } else {
          return false;
        }
      case "Mechanical":
        if (mechRoles.includes(userDetails?.role)) {
          return true;
        } else {
          return false;
        }
      case "Electrical":
      case "EICA":
        if (elecRoles.includes(userDetails?.role)) {
          return true;
        } else {
          return false;
        }
      case "Process":
      case "Process Engineering":
        if (processRoles.includes(userDetails?.role)) {
          return true;
        } else {
          return false;
        }
      case "Structural":
        if (structuralRoles.includes(userDetails?.role)) {
          return true;
        } else {
          return false;
        }
      case "Multi-disciplinary":
      case "General":
        if (generalRoles.includes(userDetails?.role)) {
          return true;
        } else {
          return false;
        }
      case "Sub-contractor":
        if (subContractorRoles.includes(userDetails?.role)) {
          return true;
        } else {
          return false;
        }

      default:
        return false;
    }
  };

  const updateSheetConfig = async (sheet) => {
    await updateProjectAssetSheetConfig(sheet);
    // selectedDrawingSet.drawingSet.drawingsetId

    refreshAssetSheets(selectedDrawingSet.drawingSet.id);
  };

  const roundButton = (disabled, sheet, discipline) => {
    return (
      <div className="col-2 sheet-centered">
        <span
          data-bs-toggle="tooltip"
          title={
            disabled
              ? "Please view the drawing set information and ensure that the drawing set is at the correct status before reviewing this sheet."
              : ""
          }
        >
          <button
            type="button"
            className="sheet-button"
            style={{
              backgroundColor: checkColour(sheet[`${discipline}Reviewed`]),
            }}
            onClick={(e) => {
              openModal(discipline, sheet);
            }}
            disabled={disabled}
          />
        </span>
      </div>
    );
  };

  const updateRequiredInSheets = (checked, discipline, index) => {
    const tempSheets = accSheets.map((sheet, idx) =>
      idx === index ? { ...sheet, [`${discipline}Required`]: checked } : sheet,
    );

    dispatch(
      updateGlobalState({
        value: tempSheets,
        stateName: ACC_SHEETS,
      }),
    );
  };

  const [showKey, setShowKey] = useState(false);

  return (
    <>
      <h4>Drawing sets</h4>

      <Select
        className="basic-single"
        placeholder="Please select a drawing set"
        options={accDrawingSets?.map((o) => {
          return {
            value:
              o?.drawingSet?.description + " - " + o?.drawingSet?.docNumber,
            label:
              o?.drawingSet?.description + " - " + o?.drawingSet?.docNumber,
            data: o,
          };
        })}
        styles={panelSelectStyles}
        isSearchable={true}
        isDisabled={isSheetsLoading}
        onChange={drawingSetSelectHandler}
        value={
          selectedDrawingSet
            ? {
                value:
                  selectedDrawingSet?.drawingSet?.description +
                  " - " +
                  selectedDrawingSet?.drawingSet?.docNumber,
                label:
                  selectedDrawingSet?.drawingSet?.description +
                  " - " +
                  selectedDrawingSet?.drawingSet?.docNumber,
                data: selectedDrawingSet,
              }
            : {
                value: "Please select a drawing set",
                label: "Please select a drawing set",
              }
        }
      />
      <div
        className="container mt-2"
        style={{ height: "75vh", overflowY: "auto" }}
      >
        {!isSheetsLoading && (
          <div style={{ marginBottom: "10px" }}>
            <button
              className="btn btn-link sheet-key-toggle-btn"
              onClick={() => setShowKey((prev) => !prev)}
            >
              {showKey ? "Hide Key" : "Show Key"}
            </button>
            {showKey && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "18px",
                  marginTop: "8px",
                }}
              >
                <div
                  style={{ display: "flex", alignItems: "center", gap: "6px" }}
                >
                  <span
                    style={{
                      display: "inline-block",
                      width: 18,
                      height: 18,
                      borderRadius: "50%",
                      backgroundColor: "green",
                      border: "1px solid #333",
                    }}
                  ></span>
                  <span style={{ fontSize: 13 }}>Reviewed / Approved</span>
                </div>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "6px" }}
                >
                  <span
                    style={{
                      display: "inline-block",
                      width: 18,
                      height: 18,
                      borderRadius: "50%",
                      backgroundColor: "orange",
                      border: "1px solid #333",
                    }}
                  ></span>
                  <span style={{ fontSize: 13 }}>Change Pending</span>
                </div>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "6px" }}
                >
                  <span
                    style={{
                      display: "inline-block",
                      width: 18,
                      height: 18,
                      borderRadius: "50%",
                      backgroundColor: "red",
                      border: "1px solid #333",
                    }}
                  ></span>
                  <span style={{ fontSize: 13 }}>Rejected / Not Reviewed</span>
                </div>
              </div>
            )}
          </div>
        )}
        {/* <div className="row sheet-centered">
          <div className="col-12 sheet-centered">
            <p className="sheet-headers">Drawing</p>
          </div>
          <div className="col-2 sheet-centered">
            <p className="sheet-headers">Civil</p>
          </div>
          <div className="col-2 sheet-centered">
            <p className="sheet-headers">Mech</p>
          </div>
          <div className="col-2 sheet-centered">
            <p className="sheet-headers">Elec</p>
          </div>
          <div className="col-2 sheet-centered">
            <p className="sheet-headers">Process</p>
          </div>
          <div className="col-2 sheet-centered">
            <p className="sheet-headers">DM</p>
          </div>
        </div> */}
        {/* {accSheets.length > 0 &&
          accSheets.map((o, i) => {
            return (
              <div
                className="row sheet-centered"
                key={i}
                style={{
                  backgroundColor:
                    selectedSheet?.sheetName === o.sheetName && "grey",
                }}
              >
                <div className="col-4 sheet-centered" style={{ padding: 0 }}>
                  <button
                    type="button"
                    className="btn btn-outline-primary sheet-name-button"
                    onClick={(e) => {
                      onSheetClick(o);
                    }}
                  >
                    <span className="sheet-name">{o.sheetName}</span>
                  </button>
                </div>
                <div className="col-2 sheet-centered">
                  <button
                    type="button"
                    className="sheet-button"
                    style={{
                      backgroundColor: checkColour(o.civilReviewed),
                    }}
                    onClick={(e) => {
                      openModal("civil", o);
                    }}
                    disabled={!isValid("Civil")}
                  ></button>
                </div>
                <div className="col-2 sheet-centered">
                  <button
                    type="button"
                    className="sheet-button"
                    style={{
                      backgroundColor: checkColour(o.mechReviewed),
                    }}
                    onClick={(e) => {
                      openModal("mech", o);
                    }}
                    disabled={!isValid("Mechanical")}
                  ></button>
                </div>
                <div className="col-2 sheet-centered">
                  <button
                    type="button"
                    className="sheet-button"
                    style={{
                      backgroundColor: checkColour(o.elecReviewed),
                    }}
                    onClick={(e) => {
                      openModal("elec", o);
                    }}
                    disabled={!isValid("Electrical")}
                  ></button>
                </div>
                <div className="col-2 sheet-centered">
                  <button
                    type="button"
                    className="sheet-button"
                    style={{
                      backgroundColor: checkColour(o.dmApproved),
                    }}
                    onClick={(e) => {
                      openModal("dm", o);
                    }}
                    disabled={
                      o.elecReviewed !== "reviewed" ||
                      o.civilReviewed !== "reviewed" ||
                      o.mechReviewed !== "reviewed" ||
                      userDetails?.role !== "Design Manager"
                    }
                  ></button>
                </div>
              </div>
            );
          })} */}
        {isSheetsLoading ? (
          <LoadingScreen
            input="LOADING"
            width="15"
            height="50%"
            variant="properties"
            transparent
            subtitle="Loading drawing set sheets..."
          />
        ) : (
          <>
            {(checkDrawingSetStatus(selectedDrawingSet) === "WIP" ||
              checkDrawingSetStatus(selectedDrawingSet) === "S1") &&
              selectedDrawingSet && (
                <div style={{ textAlign: "center" }}>
                  <p
                    className="mb-0"
                    style={{ fontSize: 14, fontWeight: "bold" }}
                  >
                    THIS DRAWING SET CANNOT BE REVIEWED IN ITS CURRENT STATE
                  </p>
                  <p style={{ fontSize: 12 }}>
                    Please view the drawing set information and ensure that each
                    model is at the correct status according to MWH Treatment
                    procedures to enable the ability to review drawings.
                  </p>
                  {/* maybe add link to procedure here later */}
                </div>
              )}
            {accSheets.length > 0 &&
              accSheets.map((o, i) => {
                // console.log("selectedDrawingSet ===", selectedDrawingSet);
                const selectedSetDiscipline =
                  selectedDrawingSet?.drawingSet?.discipline;
                // const selectedSetDiscipline =
                //   selectedDrawingSet?.drawingSet?.attributes?.name
                //     .split(".")[0]
                //     .split(" - ")[2];
                const drawingSetStatus =
                  checkDrawingSetStatus(selectedDrawingSet);
                const drawingSetNotValid =
                  drawingSetStatus === "WIP" || drawingSetStatus === "S1";
                return (
                  <div
                    className="card text-white bg-secondary mb-3"
                    style={{ maxWidth: "100%" }}
                    key={i}
                  >
                    <div
                      className="card-header sheet-header"
                      // onClick={() => onSheetClick(o)}
                    >
                      <div className="row sheet-header-row g-1 align-items-center">
                        {isValid(
                          selectedDrawingSet?.drawingSet?.discipline,
                        ) && (
                          <div className="col-auto sheet-header-action sheet-header-action--left">
                            <button
                              type="button"
                              className="btn mwh-btn-primary btn-sm sheet-action-btn"
                              onClick={() =>
                                updateSheetConfig({
                                  ...o,
                                  configured: false,
                                })
                              }
                              // disabled={selectedModels.length === 0}
                            >
                              Edit
                            </button>
                          </div>
                        )}

                        <div className="col sheet-header-title">
                          <p
                            className="card-text markup-text sheet-centered"
                            style={{
                              paddingTop: "3px",
                              color:
                                selectedSheet?.sheetName === o.sheetName &&
                                "#31c224ff",
                            }}
                          >
                            {o.sheetName}
                          </p>
                        </div>
                        <div className="col-auto sheet-header-action sheet-header-action--right">
                          <button
                            type="button"
                            className="btn btn-success btn-sm sheet-action-btn"
                            onClick={() => onSheetClick(o)}
                            // disabled={selectedModels.length === 0}
                          >
                            View
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="card-body markup-body">
                      {o.configured ? (
                        <>
                          <div className="row sheet-centered">
                            {o.civilRequired && (
                              <div className="col-2 sheet-centered">
                                <p className="sheet-headers">Civil</p>
                              </div>
                            )}
                            {o.mechRequired && (
                              <div className="col-2 sheet-centered">
                                <p className="sheet-headers">Mech</p>
                              </div>
                            )}
                            {o.elecRequired && (
                              <div className="col-2 sheet-centered">
                                <p className="sheet-headers">Elec</p>
                              </div>
                            )}
                            {o.processRequired && (
                              <div className="col-2 sheet-centered">
                                <p className="sheet-headers">Process</p>
                              </div>
                            )}
                            <div className="col-2 sheet-centered">
                              <p className="sheet-headers">DM</p>
                            </div>
                          </div>
                          <div className="row sheet-centered">
                            {o.civilRequired &&
                              roundButton(
                                !isValid("Civil") || drawingSetNotValid,
                                o,
                                "civil",
                              )}
                            {o.mechRequired &&
                              roundButton(
                                !isValid("Mechanical") || drawingSetNotValid,
                                o,
                                "mech",
                              )}
                            {o.elecRequired &&
                              roundButton(
                                !isValid("Electrical") || drawingSetNotValid,
                                o,
                                "elec",
                              )}
                            {o.processRequired &&
                              roundButton(
                                !isValid("Process") || drawingSetNotValid,
                                o,
                                "process",
                              )}
                            <div className="col-2 sheet-centered">
                              <button
                                type="button"
                                className="sheet-button"
                                style={{
                                  backgroundColor: checkColour(o.dmApproved),
                                }}
                                onClick={(e) => {
                                  openModal("dm", o);
                                }}
                                disabled={
                                  (o.elecRequired
                                    ? o.elecReviewed !== "reviewed"
                                    : false) ||
                                  (o.civilRequired
                                    ? o.civilReviewed !== "reviewed"
                                    : false) ||
                                  (o.mechRequired
                                    ? o.mechReviewed !== "reviewed"
                                    : false) ||
                                  (o.processRequired
                                    ? o.processReviewed !== "reviewed"
                                    : false) ||
                                  userDetails?.role !== "Design Manager" ||
                                  drawingSetNotValid
                                } //need to add validation check into these buttons to only be active if the drawing set is at the correct status
                              ></button>
                            </div>
                          </div>
                        </>
                      ) : isValid(selectedSetDiscipline) ? (
                        <>
                          <div className="row sheet-centered">
                            <div className="col-3 sheet-centered">
                              <p className="sheet-headers">Civil</p>
                            </div>
                            <div className="col-3 sheet-centered">
                              <p className="sheet-headers">Mech</p>
                            </div>
                            <div className="col-3 sheet-centered">
                              <p className="sheet-headers">Elec</p>
                            </div>
                            <div className="col-3 sheet-centered">
                              <p className="sheet-headers">Process</p>
                            </div>
                          </div>
                          <div className="row sheet-centered">
                            <div className="col-3 sheet-centered">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={o.civilRequired}
                                name="approved"
                                id={`civil${i}`}
                                onChange={(e) =>
                                  // setSheetConfig({
                                  //   ...sheetConfig,
                                  //   civilRequired: e.target.checked,
                                  // })
                                  updateRequiredInSheets(
                                    e.target.checked,
                                    "civil",
                                    i,
                                  )
                                }
                              />
                            </div>
                            <div className="col-3 sheet-centered">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={o.mechRequired}
                                name="approved"
                                id={`mech${i}`}
                                onChange={(e) =>
                                  // setSheetConfig({
                                  //   ...sheetConfig,
                                  //   civilRequired: e.target.checked,
                                  // })
                                  updateRequiredInSheets(
                                    e.target.checked,
                                    "mech",
                                    i,
                                  )
                                }
                              />
                            </div>
                            <div className="col-3 sheet-centered">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={o.elecRequired}
                                name="approved"
                                id={`elec${i}`}
                                onChange={(e) =>
                                  // setSheetConfig({
                                  //   ...sheetConfig,
                                  //   civilRequired: e.target.checked,
                                  // })
                                  updateRequiredInSheets(
                                    e.target.checked,
                                    "elec",
                                    i,
                                  )
                                }
                              />
                            </div>
                            <div className="col-3 sheet-centered">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                // value={sheetConfig.processRequired}
                                checked={o.processRequired}
                                name="approved"
                                id={`process${i}`}
                                onChange={(e) =>
                                  // setSheetConfig({
                                  //   ...sheetConfig,
                                  //   civilRequired: e.target.checked,
                                  // })
                                  updateRequiredInSheets(
                                    e.target.checked,
                                    "process",
                                    i,
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div
                            className="row sheet-centered"
                            style={{ paddingTop: "5px", paddingBottom: "5px" }}
                          >
                            <button
                              className="btn btn-outline-success btn-sm"
                              style={{ width: "200px" }}
                              onClick={() =>
                                updateSheetConfig({ ...o, configured: true })
                              }
                            >
                              Update Configuration
                            </button>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="row sheet-centered">
                            <div className="col sheet-centered">
                              <p className="sheet-config-text text-center ">{`Awaiting for configuration from ${
                                selectedSetDiscipline === "Electrical"
                                  ? "an"
                                  : "a"
                              } ${selectedSetDiscipline} Engineer or the Design Manager.`}</p>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                );
              })}
          </>
        )}
      </div>
      {/* MODALS */}
      <Modal
        show={modalOpen}
        onHide={onModalClose}
        dialogClassName="project-info-modal update-sheet-modal"
        centered
      >
        <Modal.Header className="project-info-modal__header update-sheet-modal__header">
          <Modal.Title>Update Sheet State</Modal.Title>
          <div
            data-bs-theme="dark"
            style={{
              position: "absolute",
              right: 20,
            }}
          >
            <button
              type="button"
              className="btn-close project-info-modal__close"
              onClick={onModalClose}
              aria-label="Close"
            />
          </div>
        </Modal.Header>
        <Modal.Body className="project-info-modal__body update-sheet-modal__body">
          <div className="row g-3 align-items-end">
            <div className="col-12">
              <Select
                className="basic-single"
                placeholder="Please select status for this sheet"
                menuPortalTarget={document.body}
                options={disciplineStateOptions}
                styles={panelSelectStyles}
                isSearchable={true}
                onChange={stateSelector}
                value={selectedState}
              />
            </div>

            <ButtonGroup className="update-sheet-modal__actions">
              <Button
                variant="outline-success"
                size="sm"
                className="project-status-modal__action-btn"
                onClick={updateState}
                disabled={!selectedState}
              >
                Update
              </Button>
            </ButtonGroup>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Sheets;
